module.exports = __webpack_public_path__ + "img/Feature.9dcea962.jpg";